export function getDomainWithoutWWW() {
    const domainParts = document.location.host.split('.');

    // for 'www.something.squadintouch.com'-like domains, skipping 'www'-part
    return domainParts[0] === 'www' ? domainParts[1] : domainParts[0];
}
